import * as php from '../../php-compat';
import { get, values, entries, array, isArray, type Storage } from './shared';
import { call, r, put, append, remove, type Ref, type DispatchEnv } from './dispatch';

/** PHP: creature_body_vanishes_active (includes/functions/janus/encounter/kill_or_vanish_creature.php:49) */
export function creatureBodyVanishesActive(item: unknown,env: DispatchEnv): boolean {
 const id=php.strval(env.deps.item_field(item,'item_id')??'');
 if(id!==''&&php.truthy(env.deps.check_uuid(id))&&php.strtolower(php.strval(env.deps.item_field(item,'item_type')??''))==='creature'){
 const own=call(env,'query_full_item_arr',{item_id:id,suppress_missing_item_warning:true});
 if(isArray(own)&&php.strval(env.deps.layer_value(own,'body_vanishes_at_zero_vitality')??'')==='1')return true;}
 for(const bucket of ['passive_ability','feat'])for(const entry of values(env.deps.layer_entries(item,bucket))){
 const id=env.deps.layer_list_entry_uuid(entry);let grantor: unknown;
 if(isArray(entry)&&!php.empty(get(entry,'item_arr'))&&isArray(get(entry,'item_arr')))grantor=get(entry,'item_arr');
 else if(id!==''&&php.truthy(env.deps.check_uuid(id))){const result=env.deps.query_full_item_arr(id);grantor=php.truthy(result)?result:null;}else grantor=null;
 if(php.empty(grantor)||!isArray(grantor))continue;
 if(!php.truthy(env.deps.layer_has(grantor,'body_vanishes_at_zero_vitality')))continue;
 if(php.truthy(env.deps.check_ability_conditions(grantor,item,false,false)))return true;
 }return false;
}
